// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a28273cc","498":"83c0df76","703":"9e23d782","897":"34610d8d"}[chunkId] + ".chunk.js";
};